import { parseDateString } from '@/server-data'

import type { CardCosmetic, YYYYMMDD } from '@/components/Calendar/typings'

export function computeTestLabel(cosmetic?: CardCosmetic) {
  if (cosmetic === 'edge-of-selection' || cosmetic === 'selected') {
    return 'selected'
  }

  if (cosmetic === 'grayed-out') {
    return 'disabled'
  }

  return undefined
}

export function computeTestId(underline?: boolean): string | undefined {
  return underline ? 'today' : undefined
}

export const parseDate = (date: YYYYMMDD): Date => parseDateString(date)
